import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { h3, paragraphRegular } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import ContentCardStyles from '@stories/Components/Cards/ContentCard/ContentCard.styles';
import CommunityFilterStyles from '@stories/Components/Listings/CommunityFilter/CommunityFilter.styles';
import FiltersStyles from '@stories/Components/Listings/Filters/Filters.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${SectionWrapperStyles.Inner} {
    display: flex;
    flex-direction: column;

    > ${ButtonStyles.Container} {
      margin: ${fluid(40, 76)} auto 0;
    }
  }

  ${FiltersStyles.Container} {
    margin: 40px 0 32px;

    @media ${from(Device.TabletLarge)} {
      margin: ${fluid(32, 36)} 0 ${fluid(42, 58)};
      position: relative;
      z-index: 3;
    }
  }
`;
const TopContainer = styled.div `
  background-color: ${brand.grey.lightest};
  padding: ${fluid(10, 22)} var(--sitePadding) 24px;
  width: calc(100% + (var(--sitePadding) * 2));
  margin: 0 calc(var(--sitePadding) * -1);
  border-radius: 0px 0px 20px 20px;

  ${Container}[data-flush='none'] & {
    border-radius: 20px;

    @media ${until(1800)} {
      margin: 0;
      width: 100%;
    }
  }
`;
const Heading = styled.h2 `
  ${h3};

  --highlightTextColour: ${brand.global.white};
  --highlightColour: ${brand.primary.purple.light};

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${brand.primary.purple.light};
  margin: 0;
  padding: ${fluid(8, 12)};

  ${TopContainer}:has(${CommunityFilterStyles.Container}) & {
    border-top: 1px solid #d9d9d9;
  }

  > span {
    ${transition('background-size, color', 0.5)};

    display: inline-block;
    background-image: linear-gradient(
      to right,
      var(--highlightColour, transparent),
      var(--highlightColour, transparent)
    );
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transition-delay: 350ms;
    color: var(--highlightTextColour, currentColor);
    padding: 0 4px;

    ${Container}[data-animate='false'] & {
      background-size: 0% 100%;
      color: currentColor;
    }
  }
`;
const ResultsGrid = styled.div `
  --rowItems: 1;

  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  gap: var(--gutterWidth);

  @media ${from(Device.Tablet)} {
    --rowItems: 2;
  }

  @media ${from(Device.TabletLarge)} {
    --rowItems: 3;
  }

  @media ${from(Device.Desktop)} {
    --rowItems: 4;
  }

  ${ContentCardStyles.Container} {
    flex: 0 0
      calc(
        100% / var(--rowItems) - (var(--gutterWidth) * ((var(--rowItems) - 1) / var(--rowItems)))
      );

    @media ${from(Device.Desktop)} {
      &[data-is-featured='true'] {
        flex: 0 0
          calc(
            200% / var(--rowItems) -
              (var(--gutterWidth) * ((var(--rowItems) - 2) / var(--rowItems)))
          );
      }
    }
  }
`;
const NoResults = styled.p `
  ${paragraphRegular};

  grid-column: 1 / -1;
  text-align: center;
`;
const ContentCardListingStyles = {
    Container,
    Heading,
    ResultsGrid,
    TopContainer,
    NoResults,
};
export default ContentCardListingStyles;
